import * as api from 'api/vendor-request';

export const fetchAllVendorRequests = params => ({
  type: 'FETCH_ALL_VENDOR_REQUESTS',
  payload: api.fetchAllVendorRequests(params),
});

export const fetchAllVendorRequestsForExport = params => ({
  type: 'FETCH_ALL_VENDOR_REQUESTS_EXPORT',
  payload: api.fetchAllVendorRequests(params),
});

export const fetchAllUpcomingRenewalVendorRequests = params => ({
  type: 'FETCH_ALL_UPCOMING_RENEWAL_VENDOR_REQUESTS',
  payload: api.fetchAllVendorRequests(params),
});

export const fetchRequestFilters = params => ({
  type: 'FETCH_REQUEST_FILTERS',
  payload: api.fetchAllVendorRequests(params),
});

export const fetchVendorRequestsByUserType = params => ({
  type: 'FETCH_VENDOR_REQUESTS_BY_USER_TYPE',
  payload: api.fetchAllVendorRequests(params),
});

export const fetchVendorRequest = id => ({
  type: 'FETCH_VENDOR_REQUEST',
  payload: api.fetchVendorRequest(id),
});

export const fetchVendorRequestHistory = id => ({
  type: 'FETCH_HISTORY',
  payload: api.fetchVendorRequestHistory(id),
});

export const fetchVendorDetails = id => ({
  type: 'FETCH_VENDOR_DETAILS',
  payload: api.fetchVendorDetails(id),
});

export const fetchAllVendors = () => ({
  type: 'FETCH_VENDOR_REQUEST_VENDOR',
  payload: api.fetchAllVendors(),
});

export const fetchVendorProducts = id => ({
  type: 'FETCH_VENDOR_REQUEST_PRODUCT',
  payload: api.fetchVendorProducts(id),
});

export const fetchRequestComments = id => ({
  type: 'FETCH_VENDOR_REQUEST_COMMENTS',
  payload: api.fetchRequestComments(id),
});

export const submitVendorRequest = request => ({
  type: 'SUBMIT_VENDOR_REQUEST',
  payload: api.submitVendorRequest(request),
});

export const fetchVendorContacts = id => ({
  type: 'FETCH_VENDOR_CONTACTS',
  payload: api.fetchVendorContacts(id),
});

export const clearVendorContacts = () => ({
  type: 'CLEAR_VENDOR_CONTACTS',
  payload: [],
});

export const clearVendorProducts = () => ({
  type: 'CLEAR_VENDOR_REQUEST_PRODUCT',
  payload: [],
});
